import React from "react";
import { cn } from "../lib/utils";

interface CheckboxProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  label?: React.ReactNode;
  helperText?: string;
  errorText?: string;
  containerClassName?: string;
}

export function Checkbox({
  label,
  helperText,
  errorText,
  containerClassName = "",
  className = "",
  ...inputProps
}: CheckboxProps) {
  return (
    <div>
      <div className={containerClassName}>
        <label className="flex items-center">
          <input
            type="checkbox"
            {...inputProps}
            className={cn("h-4 w-4 accent-blue-500", className)}
          />
          <span className="ml-2">{label}</span>
        </label>
        {errorText && (
          <div className="mt-1 pl-1 text-error text-sm">{errorText}</div>
        )}
      </div>
      {helperText && (
        <div className="mt-1 pl-6 text-gray-600 text-sm">{helperText}</div>
      )}
    </div>
  );
}
